<template>
    <div class="video-wrapper">
        <div class="video-title-wrapper">
            <div class="video-title">
                CHANNEL: FRONT CAMERA
            </div>
            <div class="video-options">
                <v-menu
                    transition="slide-y-transition"
                    bottom
                >
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn
                            class="video-btn"
                            color="primary"
                            dark
                            v-bind="attrs"
                            v-on="on"
                        >
                            <icon icon="dot-settings" color="#cacaca"></icon>
                        </v-btn>
                    </template>
                    <v-list>
                        <v-list-tile v-for="(item, i) in items" :key="item.id" class="video-select-list">
                            {{ item.title }}
                        </v-list-tile>
                    </v-list>
                </v-menu>
            </div>
        </div>
        <div class="video-img-wrapper">
            <img v-if="video.miniatureUri" class="video-img" :src="video.miniatureUri" alt="front camera">
            <plug v-else icon="images" title="No media image" :width="45" :height="55" color="#e2e2e2"></plug>
        </div>
    </div>
</template>

<script>
import Icon from '@/components/atoms/Icon'
import Plug from '@/components/atoms/Plug'

export default {
    name: 'VideoItem',
    components: { Icon, Plug },
    data () {
        return {
            items: [
                { title: 'Option 1' },
                { title: 'Option 2' },
                { title: 'Option 3' }
            ]
        }
    },
    props: {
        video: {
            type: Object,
            required: true
        }
    },
}
</script>

<style scoped lang="scss">

.video-wrapper {
    border-left: 4px solid #bebebe;
    padding: 15px 20px 5px;
    box-shadow: 0 2px 9px #b0b0b0;
    margin-top: 10px;
    margin-left: 5px;
}

.video-title-wrapper {
    display: flex;
    justify-content: space-between;
}

.video-title {
    font-weight: 700;
    color: #666666;
    font-size: 11px;
    margin-bottom: 5px;
}

.video-options {
    cursor: pointer;
    position: relative;
}

::v-deep .v-list {
    padding: 0;
    .video-select-list {
        display: flex;
        flex-direction: column;
        border-bottom: 1px solid #cacaca;
        font-size: 14px;
        font-weight: 700;
        transition: opacity 0.3s;
        cursor: pointer;
        .v-list__tile {
            height: 35px;
        }

        &:last-child {
            border-bottom: none;
        }

        &:hover {
            opacity: 0.5;
        }
    }
}


.video-img-wrapper {
    width: 180px;
}

.video-img {
    width: 100%;
    height: 165px;
    object-fit: cover;
}

.video-btn {
    background-color: transparent !important;
    box-shadow: none !important;
    height: auto !important;
}

</style>
